class ShoppableHotspot extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.shoppable-image__pin');
    this.button.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = this.classList.contains('shoppable-image__hotspot--open');
      document
        .querySelectorAll('.shoppable-image__hotspot--open')
        .forEach((el) => el.classList.remove('shoppable-image__hotspot--open'));
      if (!isOpen) this.classList.add('shoppable-image__hotspot--open');
    });
  }
}

customElements.define('shoppable-hotspot', ShoppableHotspot);

document.addEventListener('click', () => {
  document
    .querySelectorAll('.shoppable-image__hotspot--open')
    .forEach((el) => el.classList.remove('shoppable-image__hotspot--open'));
});
